import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa79fafa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col-ter-ard" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "options" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "flag abs"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }

import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useRtfix } from '@/store'
import Tooltip from '@/components/common/Tooltip.vue'
import MemberEventBox from '@/components/common/MemberEventBox.vue'

import { ElMessage, ElMessageBox } from 'element-plus'
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: ['node'],
  emits: ['next'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()
const user = computed(() => store.getters.user)



const isSame = (v: any) => props.node.data[props.node.key] === v.value

const select = (v: any) => {
  const { node } = props
  const t = isSame(v)
  node.data[node.key] = v.value
  v.bridge && (node.bridge = v.bridge)
  emit('next', t ? v.next : [v.next])
}

const route = useRoute()
const router = useRouter()
const confirmMember = () => {
  ElMessageBox.confirm(
    t('升级成商务舱及以上就可享用更多寻源服务'),
    t('请注意'),
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: t('充值会员'),
      cancelButtonText: t('关闭'),
      distinguishCancelAndClose: true,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      type: 'warning'
    }
  )
    .then(() => {
      const routerUrl: any = router.resolve(useRtfix('VipLevel'))
      window.open(routerUrl.href, '_black')
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(__props.node.title)), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.node.options, (v, i) => {
      return (_openBlock(), _createBlock(MemberEventBox, {
        key: v.label,
        icon: "member_oem",
        fn: confirmMember,
        memberLevel: v.memberLevel
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Tooltip, {
              tooltip: v.tooltip,
              "tip-option": v.tipOption
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["rel", { long: __props.node.long }]),
                  onClick: ($event: any) => (select(v))
                }, [
                  (isSame(v))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(String.fromCodePoint(65 + i)), 1),
                  (!__props.node.long)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, ". "))
                    : _createCommentVNode("", true),
                  (__props.node.long)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(t)(v.label).split('\n'), (text) => {
                          return (_openBlock(), _createElementBlock("div", { key: text }, _toDisplayString(text), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(v.labelJP ? v.labelJP : _unref(t)(v.label)), 1))
                ], 10, _hoisted_4)
              ]),
              _: 2
            }, 1032, ["tooltip", "tip-option"])
          ])
        ]),
        _: 2
      }, 1032, ["memberLevel"]))
    }), 128))
  ]))
}
}

})